<template>
    <div class="table-container">
        <el-table
            :data="admins"
            v-loading="isLoading"
            size="small"
        >
            <el-table-column
                prop="_username"
                label="用户名"
                width="140"
                show-overflow-tooltip
            >
                <template slot-scope="props">
                    <div class="name">
                        <el-avatar :src="props.row.avatar" size="small"/>
                        {{props.row._username}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="nickname"
                label="昵称"
                width="140"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="_phone"
                label="电话"
                width="140"
            >
                <template slot-scope="scope">
                    {{scope.row._phone||'▨▨▨▨▨▨▨'}}
                </template>
            </el-table-column>
            <el-table-column
                prop="_email"
                label="Email"
                show-overflow-tooltip
                min-width="180"
            >
            </el-table-column>
            <el-table-column
                prop="is_admin"
                label="状态"
                width="90"
                align="center"
            >
                <template slot-scope="props">
                    <el-tag v-if="props.row.is_admin===0" size="mini" type="primary">待处理</el-tag>
                    <el-tag v-else-if="props.row.is_admin===1" size="mini" type="success">已通过</el-tag>
                    <el-tag v-else-if="props.row.is_admin===-1" size="mini" type="danger">已拒绝</el-tag>
                    <el-tag v-else size="mini" type="info">未知状态</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                prop="is_sa"
                label="超级管理员"
                width="90"
                align="center"
                :formatter="boolFormatter"
            ></el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="140"
                align="center"
            >
                <template slot-scope="scope">
                    <el-button disabled type="text" size="small" v-if="scope.row.is_handled">已处理</el-button>
                    <states-button
                        type="text"
                        size="small"
                        @change="(state) => onStateChange(scope.row, state)"
                        :states="[{name:'通过', value:1},{name:'拒绝', value:-1}]"
                    >修改状态</states-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { fmtMixin } from "@/ox/Mixins";
import StatesButton from '@/components/StatesButton';

const states = {
    '所有': null,
    '待处理':  0,
    '已通过': 1,
    '已拒绝': -1
}

export default {
    name: "ApplicationTable",
    mixins: [fmtMixin],
    components:{
        StatesButton
    },
    data: function() {
        return {
            isLoading: false,
            admins: []
        };
    },

    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData() {
            this.isLoading = true
            const query = new window.BaaS.Query();
            query.isNotNull('is_admin')
            const {filter} = this.$parent;
            const state = states[filter.state];
            if(state!==null){
                query.compare('is_admin', '=', state);
            }
            if(filter.keyword){
                query.contains(filter.column, filter.keyword.trim())
            }
            let User = new window.BaaS.User();
            User.setQuery(query).limit(100).orderBy(['-created_at']).find()
                .then(res => {
                    this.isLoading = false;
                    this.admins = res.data.objects;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        onPageChange(page) {
            this.loadData(page);
        },
        onStateChange(row, state) {
            window.BaaS.invoke('update_user',{uid: row.id, data:{is_admin: state}}).then(() => {
                this.admins = this.admins.map(admin => {
                    if(admin.id === row.id){
                        admin.is_admin = state
                    }
                    return admin;
                })
                this.$notify.success({
                  title: '操作成功',
                  message: `管理员“${row._username}”状态已更改`
                });
            });
        }
    }
};
</script>

<style scoped>
.name{
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.name .el-avatar{
    margin-right: 10px;
}
</style>
